module.exports = {
  BASE_API_URL: `${process.env.VUE_APP_BASE_API_URL}api`,
  LOCALHOST_SITE_URL: process.env.VUE_APP_BASE_SITE_URL,
  PROD_SITE_URL: process.env.VUE_APP_PROD_URL,
  SOCKET_URL: process.env.VUE_APP_BASE_API_URL,
};
